import { render, staticRenderFns } from "./courseLeadersModal.vue?vue&type=template&id=28324180&scoped=true&lang=pug"
import script from "./courseLeadersModal.vue?vue&type=script&lang=js"
export * from "./courseLeadersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28324180",
  null
  
)

export default component.exports